import * as React from 'react'
import ThinkportLogo from '../../assets/images/sponsors/thinkport-no-text.svg'

function SponsorLogoNoText() {
    return (
        <div>
            <a href="https://thinkport.digital" target="_blank" rel="noopener noreferrer" className="pr-4 lg:pr-8 text-[10px]  flex flex-row items-center">
                Powered by <span className="hidden lg:block">Thinkport</span>
                <img 
                    className="lazy loaded" 
                    style={{ height: 45 }}
                    src={ThinkportLogo}
                    alt="Thinkport Logo"
                />
            </a>
        </div>
    )
}

export default SponsorLogoNoText
